import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Components
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import BookDemoModal from './components/Modal/BookDemoModal';
import BookingConfirmed from './components/BookingConfirmed';
import DashboardShowcase from './components/Dashboard/DashboardShowcase';
import Features from './components/Features/Features';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Testimonials from './components/Testimonials/Testimonials';
import FAQ from './components/FAQ/FAQ';
import CTA from './components/CTA/CTA';
import Footer from './components/Footer/Footer';
import { ScrollProgress, WhatsAppButton } from './components/UI';

// Pages
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

// Home Page Component
const LandingPage = ({ isModalOpen, setIsModalOpen, showBookingConfirmed, setShowBookingConfirmed }) => {
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleBookingConfirmedDone = () => {
    setShowBookingConfirmed(false);
  };

  return (
    <>
      {/* Navigation */}
      <Navbar onBookDemo={openModal} />

      {/* Main Content */}
      <main>
        <Hero onBookDemo={openModal} />
        {/* <DashboardShowcase /> */}
        <Features />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <CTA onBookDemo={openModal} />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating WhatsApp Button */}
      {/* <WhatsAppButton /> */}

      {/* Book Demo Modal */}
      <BookDemoModal isOpen={isModalOpen} onClose={closeModal} />

      {/* Booking Confirmed Screen (shown after Calendly redirect) */}
      {showBookingConfirmed && (
        <BookingConfirmed onDone={handleBookingConfirmedDone} />
      )}
    </>
  );
};


export default LandingPage;